<template>
  <form @submit.prevent="submitForm()" @reset.prevent="resetForm()">
    <p>Введите код, полученный в смс и мы пришлём вам новый пароль в смс.</p>
    <div class="my-1">
      <div class="input-group">
        <div class="input-group-text"><font-awesome-icon icon="fa-solid fa-key" /></div>
        <input type="text" name="code" v-model="form.code" class="form-control" placeholder="код из смс" />
        <div v-if="errors.form.code.length" class="invalid-feedback">{{ errors.form.code }}</div>
      </div>
    </div>

    <div v-if="seconds > -1" class="my-1">
      <small v-if="seconds == 0" class="text-muted">Код истёк, получите новый.</small>
      <small v-if="seconds > 0" class="text-muted">Действует ещё {{ secondsFormatted }}.</small>
    </div>

    <div data-error class="alert alert-info mb-1 mt-3 px-2 py-1" role="alert">{{ errors.form.common }}</div>

    <div class="mt-2 mb-1 text-end">
      <button type="reset" class="btn btn-secondary-outline" :disabled="isLoading" title="Вернуться">
        <font-awesome-icon icon="fa-solid fa-arrow-left" /> Назад
      </button>
      <button type="submit" class="btn btn-primary" :disabled="isLoading" title="Войти на сайт">
        <font-awesome-icon icon="fa-solid fa-user" /> Отправить
      </button>
    </div>
  </form>
</template>

<script>
import axios from 'axios';

import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faKey, faArrowLeft, faUser } from '@fortawesome/free-solid-svg-icons';
library.add(faKey, faArrowLeft, faUser);

export default {
  data: function () {
    return {
      isLoading: false,
      //
      form: {
        _token: this.csrf,
        uid: '',
        code: '',
      },
      errors: {
        form: {
          code: '',
          common: '',
        },
      },
      // таймер
      timer: null,
      seconds: -1,
    };
  },
  props: {
    csrf: {
      type: String,
      default: '',
    },
    uid: {
      type: Number,
      default: 0,
    },
    until: {
      type: String,
      default: '',
    },
  },
  components: {
    FontAwesomeIcon,
  },
  methods: {
    submitForm() {
      // убрать старые ошибки
      Object.keys(this.errors.form).forEach((key) => {
        this.errors.form[key] = '';
      });

      if (this.form.code === '') {
        this.errors.form.common = 'Нужно ввести код из смс.';

        return false;
      }

      this.isLoading = true;

      axios
        .post(`/backend/profile/remind/sms/response`, this.form)
        .then((res) => {
          const { data } = res;

          // ??? надо?
          if (data.message !== '') {
            this.$bs5utils.Snack.show('info', data.message, this.$store.getters.delay.info);
          }

          if (data.status === 'ok') {
            this.errors.form.common = data.message;
            this.form.uid = 0;
            this.form.code = '';

            this.$emit('go-step', { step: 'step3', uid: 0, code: '' });
          }

          if (data.status === 'error') {
            const errors = data.errors || {};
            const fieldErrors = errors.validation || {};
            const customErrors = errors.customErrors || {};
            const commonErrors = errors.common || [];

            Object.keys(fieldErrors).forEach((key) => {
              this.errors.form[key] = fieldErrors[key].join(' ');
            });

            Object.keys(customErrors).forEach((key) => {
              this.errors.form[key] = customErrors[key].join(' ');
            });

            this.errors.form.common = commonErrors.join(' ');
          }
        })
        .catch((err) => {
          this.errors.form.common = 'Ошибка на сервере, обновите страницу и попробуйте ещё раз.';
          console.error(err);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    resetForm() {
      this.$emit('go-step', { step: 'step1', uid: '', until: '' });
    },
    until_seconds() {
      const now = new Date();
      const [h, m, s] = this.until.split(':').map(Number);

      let target = new Date();
      target.setHours(h, m, s, 0);

      if (target < now) {
        // если время меньше, то добавить 1 день
        // target.setDate(target.getDate() + 1);
        // если прошло, то вернуть 0
        return 0;
      }

      return Math.floor((target - now) / 1000);
    },
    until_timer() {
      clearInterval(this.timer);

      this.timer = setInterval(() => {
        this.seconds = this.until_seconds();

        if (this.seconds == 0) {
          clearInterval(this.timer);
        }
      }, 1000);
    },
  },
  computed: {
    secondsFormatted() {
      const s = parseInt(this.seconds);
      if (s == -1) {
        return '';
      }

      const tm = Math.floor(s / 60) ? `${Math.floor(s / 60)} мин. ` : '';
      const ts = `${(s % 60).toString().padStart(2, '0')} сек.`;

      return `${tm}${ts}`;
      // return `${Math.floor(s / 60)}:${(s % 60).toString().padStart(2, '0')}`;
    },
  },
  created() {
    this.form.uid = this.uid;
  },
  mounted() {
    if (this.until.length) {
      this.until_timer();
    }
  },
};
</script>
